import { FC } from 'react';

import { Col, Form, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { PlantForm } from '@/types/plant';
import { normalizePositiveNumericValuesInput } from '@/utils';

type Props = {
  disabled?: boolean;
};

const GridActions: FC<Props> = ({ disabled = false }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Form.Item
      className="p-16 pb-40"
      style={{
        border: '0.5px solid',
        borderRadius: '10px',
        borderColor: theme.colors.grayLightAccent,
      }}
    >
      <Row>
        <Col span={24}>
          <Form.Item<PlantForm>
            className="pr-8"
            name="gridPowerConstraintOutflow"
            label={t(
              'plants.form.gridActions.gridPowerConstraintOutflow.label'
            )}
            normalize={normalizePositiveNumericValuesInput}
            rules={[
              {
                required: true,
                message: t(
                  'plants.form.gridActions.gridPowerConstraintOutflow.requiredMessage'
                ),
              },
            ]}
          >
            <Input
              disabled={disabled}
              addonAfter={t('plants.form.gridActions.units.mw')}
              placeholder={t(
                'plants.form.gridActions.gridPowerConstraintOutflow.placeholder'
              )}
            />
          </Form.Item>
        </Col>
        {/* <Col span={12}>
          <Form.Item<PlantForm>
            //TODO Reusable FormTooltips
            tooltip={{
              title: (
                <div>
                  <>
                    <Typography.Text className="fs-14-semi-bold">
                      {t(
                        'plants.form.gridActions.distributionFeePerMwh.tooltip.title'
                      )}
                    </Typography.Text>
                    <div className="horizontal-line mt-4"></div>
                  </>
                  <Typography.Text className="fs-14-regular smoke mt-4">
                    {t(
                      'plants.form.gridActions.distributionFeePerMwh.tooltip.description'
                    )}
                  </Typography.Text>
                </div>
              ),
              styles: {
                body: {
                  padding: theme.spacing.spacing12 + 'px',
                  color: 'inherit',
                },
              },
              color: theme.colors.light,
            }}
            className="pl-8"
            name="distributionFeePerMwh"
            label={t('plants.form.gridActions.distributionFeePerMwh.label')}
            normalize={normalizePositiveNumericValuesInput}
          >
            <Input
              disabled={disabled}
              addonAfter={t('plants.form.gridActions.units.dollarsPerMwh')}
              placeholder={t(
                'plants.form.gridActions.distributionFeePerMwh.placeholder'
              )}
            />
          </Form.Item>
        </Col> */}
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item<PlantForm>
            className="pr-8"
            name="gridPowerConstraintInflow"
            label={t('plants.form.gridActions.gridPowerConstraintInflow.label')}
            normalize={normalizePositiveNumericValuesInput}
            rules={[
              {
                required: true,
                message: t(
                  'plants.form.gridActions.gridPowerConstraintInflow.requiredMessage'
                ),
              },
            ]}
          >
            <Input
              disabled={disabled}
              addonAfter={t('plants.form.gridActions.units.mw')}
              placeholder={t(
                'plants.form.gridActions.gridPowerConstraintInflow.placeholder'
              )}
            />
          </Form.Item>
        </Col>
        {/* <Col span={12}>
          <Form.Item<PlantForm>
            className="pl-8"
            name="withdrawalFeePerMwh"
            label={t('plants.form.gridActions.withdrawalFeePerMwh.label')}
            normalize={normalizePositiveNumericValuesInput}
            //TODO Reusable FormTooltips
            tooltip={{
              title: (
                <div>
                  <>
                    <Typography.Text className="fs-14-semi-bold">
                      {t(
                        'plants.form.gridActions.withdrawalFeePerMwh.tooltip.title'
                      )}
                    </Typography.Text>
                    <div className="horizontal-line mt-4"></div>
                  </>
                  <Typography.Text className="fs-14-regular smoke mt-4">
                    {t(
                      'plants.form.gridActions.withdrawalFeePerMwh.tooltip.description'
                    )}
                  </Typography.Text>
                </div>
              ),
              styles: {
                body: {
                  padding: theme.spacing.spacing12 + 'px',
                  color: 'inherit',
                },
              },
              color: theme.colors.light,
            }}
          >
            <Input
              disabled={disabled}
              addonAfter={t('plants.form.gridActions.units.dollarsPerMwh')}
              placeholder={t(
                'plants.form.gridActions.withdrawalFeePerMwh.placeholder'
              )}
            />
          </Form.Item>
        </Col> */}
      </Row>
    </Form.Item>
  );
};

export default GridActions;
